import { getHeaders } from "./api"
import { PrismMemoryError } from "./memory"

/** Delegated Prism pending_auth is not an expired Hello AI login. */
export async function fetchPrismAppRequest(
  url: string,
  options: RequestInit,
  idToken?: string
): Promise<Response> {
  const response = await fetch(url, {
    ...options,
    headers: options.headers ?? getHeaders(idToken),
    cache: "no-store",
  })
  if (!response.ok) {
    const body = (await response
      .clone()
      .json()
      .catch(() => null)) as { error?: string } | null
    if (body?.error === "pending_auth") throw new PrismMemoryError("pending_auth", response.status)
    throw new PrismMemoryError("unavailable", response.status)
  }
  return response
}
